import { Trans } from '@ecomm/i18n'
import { useTranslation } from '@ecomm/i18n'
import { ComparisonCell } from '../ComparisonCell'
import { ComparisonRow } from '../ComparisonRow'

export function RowCamera() {
  const { t } = useTranslation('maps')

  return (
    <ComparisonRow
      title={t('feature-title.multi-cameras-business')}
      description={t('feature-description.multi-cameras-business')}
      modalDescription={
        <Trans t={t} i18nKey="feature-tooltip.multi-cameras-business" />
      }
    >
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
      <ComparisonCell included={true} />
    </ComparisonRow>
  )
}
